import { defaultInstance } from 'src/api/instance';
import { configVars } from 'src/helpers';

export const fetchReclassificationRequeue = async (
  proofId: string,
  type: string
): Promise<boolean> => {
  const body = (await defaultInstance.get(
    `${configVars.server_url}/v2/proofs/${proofId}/reclassification_impact`,
    { params: { type }, timeout: 10000 }
  )) as unknown as { requeue: boolean };
  return body.requeue;
};
